import React from "react";
import Accordion from "../../../common/accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import { LABELS } from "../../../../constants/labels/help.labels";

const Protector: React.FC = () => {
    const {
        oilContractionCollapse,
        protectorCollapse,
    } = useAppSelector((state) => state?.collapse);

    const {
        updateOilContractionCollapse,
        updateProtectorCollapse,
    } = useCollapseFacade();

    const handleCollapseChange = (key: boolean, name: string) => {
        if (name === "OilContraction") updateOilContractionCollapse(key);
        else if (name === "Protc") updateProtectorCollapse(key);
    };

    return (
        <div className="flex flex-col justify-center item-center w-full h-full gap-[16px] text-white">
            <Accordion
                title={LABELS?.protectorCalculations}
                id={'Protc'}
                isOpen={!protectorCollapse}
                onToggle={() =>
                    handleCollapseChange(!protectorCollapse, "Protc")
                }
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="w-full table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Force on thrust bearing</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            Imperial unitsystem
                                        </div>
                                        <div className="pb-4 secondary">
                                            ThrustForce = 0.785
                                            * Pmax *
                                            (ShaftDia^2)</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                PMax = MaxYCord
                                                * numberOfStages
                                                * Pl *
                                                0.433 / 62.4</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ycord = H0 + H1
                                                * xcord + H2 *
                                                (xcord^2) + H3
                                                *(xcord^2) + H4
                                                * (xcord^2) + H5 * (xcord^2);
                                            </p>
                                            <p className="secondary-text">
                                                xcord = xcord +
                                                capacityMax / n;
                                            </p>
                                            <p className="secondary-text">
                                                MaxYCord greater
                                                than ycord
                                            </p>
                                            <p className="secondary-text">
                                                MaxYCord =
                                                ycord;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                Metric
                                                unitSystem</p>
                                            <p className="secondary-text">
                                                PumpMax = PMax *
                                                6.89476
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                Imperial
                                                unitSystem</p>
                                            <p className="secondary-text">
                                                PumpMax = PMax;
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            Metric unitSystem
                                        </div>
                                        <div className="pb-4 secondary">
                                            ThrustForce = 0.785
                                            * Pressure
                                            *
                                            (ShaftDia^2)
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                Pressure
                                                = Pmax *
                                                0.145038</p>
                                            <p className="secondary">
                                                ShaftDia
                                                = ShaftDia *
                                                0.0393701</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                PMax = MaxYCord
                                                * numberOfStages
                                                * convertPl *
                                                0.433 / 62.4</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ycord = H0 + H1
                                                * xcord + H2 *
                                                (xcord^2) + H3
                                                *(xcord^2) + H4
                                                * (xcord^2) + H5
                                                *
                                                (xcord^2);
                                            </p>
                                            <p className="secondary-text">
                                                xcord = xcord +
                                                capacityMax / n;
                                            </p>
                                            <p className="secondary-text">
                                                MaxYCord greater
                                                than ycord
                                            </p>
                                            <p className="secondary-text">
                                                MaxYCord =
                                                ycord;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                Metric
                                                unitSystem</p>
                                            <p className="secondary-text">
                                                PumpMax = PMax *
                                                6.89476
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                Imperial
                                                unitSystem</p>
                                            <p className="secondary-text">
                                                PumpMax = PMax;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                ThrustForce is
                                                selected</p>
                                            <p className="secondary-text">
                                                ThrustBearingForce=ThrustForce
                                                * 0.453592
                                            </p>
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Protector HS shaft rating </th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <p className="secondary">
                                            (shaftRating *
                                            (opFreq)) / 60
                                        </p>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Thrust
                                        bearing max. load</th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="secondary">
                                            ThrustBearingMaxLoad
                                        </div>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Total BHP
                                    </th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            totbasicGasHP +
                                            (chgPmp1Val
                                            + chgPmp2Val +
                                            chgPmp3Val)
                                        </div>
                                        <div className="pb-4 secondary">
                                            totbasicGasHP=
                                            pmpTotBHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">noOfGasSep greater
                                                than 0</p>
                                            <p className="secondary-text">
                                                totbasicGasHP1 =
                                                (
                                                GasSeparatorsPowerRating
                                                * noOfGasSep ) +
                                                pmpTotBHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                useOfChPmp is
                                                selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP2 =
                                                totbasicGasHP1 +
                                                GasHandlersPowerRating
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                lwrHP is not
                                                selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP3 =
                                                totbasicGasHP2 +
                                                lwrHPVal;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                uprHPVal is not
                                                selected
                                            </p>
                                            <p className="secondary-text">
                                                totbasicGasHP4 =
                                                totbasicGasHP3 +
                                                uprHPVal
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChPmpSelVal is
                                                selected
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp1Val =
                                                CP1_HPRating
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp2Val =
                                                CP2_HPRating
                                            </p>
                                            <p className="secondary-text">
                                                chgPmp3Val =
                                                CP3_HPRating
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary">
                                                totbasicGasHP =
                                                totbasicGasHP4
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Percent thrust bearing load
                                    </th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <p className="secondary">
                                            (ForceOnThrustBearing
                                            /
                                            ThrustBearingMaxLoad)
                                            * 100
                                        </p>
                                    </td>
                                    <th className="col-1 px-[24px] py-[16px] font-normal">Percent of protector shaft load
                                    </th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <p className="secondary">
                                            (Total BHP /
                                            ProtractorShaftRating)
                                            * 100
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            ></Accordion>
            <Accordion
                title={LABELS?.OilContraction}
                id={'OilContraction'}
                isOpen={!oilContractionCollapse}
                onToggle={() =>
                    handleCollapseChange(!oilContractionCollapse, "OilContraction")
                }
                content={
                    <div className="flex justify-center items-center bg-darkcolor-800 p-[16px] w-full rounded-br-lg rounded-bl-lg">
                        <div className='pad-all w-full bg-darkcolor-700 border-[1px] border-darkcolor-400 rounded-lg'>
                            <table className="table table-striped table-bordered dtr-inline">
                                <colgroup>
                                    <col style={{ width: "20%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "40%", borderRight: "1px solid #4a5463" }} />
                                    <col style={{ width: "40%" }} />
                                </colgroup>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="px-[24px] py-[16px]"></th>
                                    <th className="col-5 align-center px-[24px] py-[16px]">Operation (%)</th>
                                    <th className="col-5 align-center px-[24px] py-[16px]">Pull (%)</th>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">LT chamber #1 contraction</th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            LT chamber #1 contraction operation (%)= chamberLowerOps * 100;</div>
                                        <div className="pb-4">
                                            <p className="secondary">chamberLowerOps :</p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerOps :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolLower;</p>
                                            <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = ( MaxMotorOperatingTemp ) Operating temp
                                                from motor performance data table motor tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower= ChamberCountLower
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps :</p>
                                            <p className="secondary-text pb-4">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                            <p className="secondary">MotorOilVolume : </p>
                                            <p className="secondary-text">
                                                (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL" && " PSSB" </p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            LT chamber #1 contraction pull (%)= chamberLowerPull * 100;</div>
                                        <div className="pb-4">
                                            <p className="secondary"> chamberLowerPull :</p>
                                            <p className="secondary-text">
                                                (chamberVolLowerPull + MotorOilPull) / factor1Lower;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull :</p>
                                            <p className="secondary-text">
                                                ChamberVolLower from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull = (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps = (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                            <p className="secondary-text">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                            <p className="secondary-text">
                                                MotorHP = convertedMotorHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL" && "PSSB"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">LT chamber #2 contraction</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            operation_LTChamber2Contraction operation %= chamberLowerOps * 100;</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberLowerOps :</p>
                                            <p className="secondary-text">
                                                ((chamberVolLowerOps + chamberVolLowerOps + MotorOilOps) /
                                                factor1Lower);</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerOps :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolLower;</p>
                                            <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = ( MaxMotorOperatingTemp ) Operating temp
                                                from motor performance data table motor tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower= ChamberCountLower
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)</p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL" && " PSSB"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            pull_LTChamber2Contraction Pull (%)= chamberLowerPull * 100
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberLowerPull : </p>
                                            <p className="secondary-text">
                                                ((chamberVolLowerPull + chamberVolLowerPull +
                                                MotorOilPull) / factor1Lower);
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull :</p>
                                            <p className="secondary-text">
                                                ChamberVolLower from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                            <p className="secondary-text">
                                                MotorHP = convertedMotorHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL" && "PSSB"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]</p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">LT chamber #3 contraction</th>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            LT chamber #3 contraction operation (%)= chamberLowerOps * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberLowerOps : </p>
                                            <p className="secondary-text">
                                                ((chamberVolLowerOps + chamberVolLowerOps + chamberVolLowerOps +
                                                MotorOilOps) / factor2Lower);</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolLower;
                                            </p>
                                            <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp =( MaxMotorOperatingTemp )Operating temp
                                                from motor performance data table motor tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower= ChamberCountLower
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL" && " PSSB"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Lower = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Lower = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]</p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            LT chamber #3 contraction pull %= chamberUpperPull * 100;</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberUpperPull : </p>
                                            <p className="secondary-text">
                                                ((chamberVolLowerPull + chamberVolLowerPull + chamberVolLowerPull +
                                                chamberVolUpperPull + MotorOilPull) /
                                                factor1Upper)</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull : </p>
                                            <p className="secondary-text">
                                                ChamberVolLower from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                            <p className="secondary-text">
                                                MotorHP = convertedMotorHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]</p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">UT chamber #1 contraction</th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT Chamber #1 Contraction Operation (%)= chamberUpperOps * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberUpperOps:
                                            </p>
                                            <p className="secondary-text">
                                                ((chamberVolLowerOps + chamberVolUpperOps) / factor1Upper)</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerOps :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolLower;</p>
                                            <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = ( MaxMotorOperatingTemp )Operating temp
                                                from motor performance data table motor tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower,ChamberVolUpper = ChamberCountLower
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower;
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps :</p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ]</p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5 px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT chamber #1 contraction pull (%)= chamberUpperPull * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberUpperPull : </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerPull + chamberVolUpperPull) / factor1Upper</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull =ChamberVolLower from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolUpperPull =ChamberVolUpper from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * ChamberVolLower[i];</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="border-b-[1px] border-darkcolor-400 align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">UT chamber #2 contraction</th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT chamber #2 contraction operation (%)= chamberUpperOps * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary"> chamberUpperOps : </p>
                                            <p className="secondary-text">
                                                chamberVolUpperOps[1] / factor2Upper;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolUpperOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolUpper</p>
                                            <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = ( MaxMotorOperatingTemp )Operating temp
                                                from motor performance data table motor tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower= ChamberCountLower
                                            </p>
                                            <p className="secondary -text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT chamber #2 contraction pull (%)= chamberUpperPull * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberUpperPull : </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerPull + chamberVolUpperPull) / factor1Upper</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull : </p>
                                            <p className="secondary-text">
                                                ChamberVolLower from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                            <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                            <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected protectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="align-center text-[14px] font-normal">
                                    <th className="col-1 px-[24px] py-[16px] font-normal">UT chamber #3 contraction</th>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT chamber #3 contraction operation (%)= chamberUpperOps * 100</div>
                                        <div className="pb-4">
                                            <p className="secondary"> chamberUpperOps : </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + chamberVolUpperOps + chamberVolUpperOps +
                                                +chamberVolUpperOps) / factor2Upper</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolUpperOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp -
                                                BottomholeTemp) * ThermalExpansionCoefficient *
                                                ChamberVolUpper</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * ChamberVolLower</p>
                                                <p className="secondary-text">
                                                BottomholeTemp = (BottomHoleTemperature) Bottom hole temp from
                                                fluid tab </p>
                                                <p className="secondary-text">
                                                MaxMotorOperatingTemp = ( MaxMotorOperatingTemp )Operating temp
                                                from motor performance data table motor tab</p>
                                                <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                                <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                ChamberVolLower= ChamberCountLower
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                Selected VolExpression from ESP catalog (DR_MotorSeries table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4 secondary">
                                            MotorHP = convertedMotorHP
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                    <td className="col-5  px-[24px] py-[16px]">
                                        <div className="pb-4 secondary">
                                            UT chamber #3 contraction (%)= chamberUpperPull * 100</div>

                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberUpperPull : </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerPull + chamberVolUpperPull + chamberVolUpperPull +
                                                chamberVolUpperPull) / factor2Upper</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolUpperPull : </p>
                                            <p className="secondary-text">
                                                chamberVolUpperPull from DR_Protectors</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                chamberVolLowerPull : </p>
                                            <p className="secondary-text">
                                                ChamberVolLower from DR_Protectors</p>
                                        </div>

                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilPull : </p>
                                            <p className="secondary-text">
                                                (MaxMotorOperatingTemp - SurfaceTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;
                                            </p>
                                            <p className="secondary-text">
                                                MaxMotorOperatingTemp = Operating temp from motor performance data table
                                                motor tab </p>
                                                <p className="secondary-text">
                                                SurfaceTemp = Surface temperature from fluid tab</p>
                                                <p className="secondary-text">
                                                ThermalExpansionCoefficient = Selected ThermalExpansionCoefficient from ESP
                                                catalog (DR_MotorOIlTypes table in database) </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilVolume = (VolExpression ,MotorHP)
                                            </p>
                                            <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorOilOps : </p>
                                            <p className="secondary-text">
                                                (convertedMaxMotorOperatingTemp - BottomholeTemp) *
                                                ThermalExpansionCoefficient * MotorOilVolume;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                            <p className="secondary-text">
                                                (chamberVolLowerOps + MotorOilOps) / factor1Lower </p>
                                                <p className="secondary-text">
                                                VolExpression = Selected VolExpression from ESP catalog (DR_MotorSeries
                                                table in database)
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                MotorHP = convertedMotorHP
                                            </p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"BSBSL":</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 2 * 0.9;</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorOutsideBagVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">"LSL" && "LSLSL" && "66L"</p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorLabVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;</p>
                                        </div>
                                        <div className="pb-4">
                                            <p className="secondary">
                                                " PSSB": </p>
                                            <p className="secondary-text">
                                                factor1Upper = ProtectorInsideBagVol * 0.9;</p>
                                            <p className="secondary-text">
                                                factor2Upper = ProtectorLabVol * 0.9;
                                            </p>
                                        </div>
                                        <div>
                                            <p className="secondary-text">
                                                [ ProtectorInsideBagVol , ProtectorLabVol , ProtectorThrustChamberVol ,
                                                ProtectorOutsideBagVol ] </p>
                                            <p className="secondary-text">
                                                Selected ProtectorSeries from ESP catalog (DR_ProtectorSeries table in
                                                database)</p>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }
            />
        </div>
    );

}


export default Protector;
